module.exports = __webpack_public_path__ + "static/media/6@3x.a2e4078e.png";